module.exports = __webpack_public_path__ + "static/img/2.3b53246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-img/2.jpg
// module id = vceQ
// module chunks = 1